import React, { useContext } from 'react';
import './LoginScreen.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import loginIllustration from './images/login-illustration.png';
import logoWaterSystem from './images/logo-gracanica.png';
import { ReactComponent as UserIcon } from './images/user.svg';
import { ReactComponent as PasswordIcon } from './images/lock.svg';
import { UserContext } from '../App';

const LoginScreen = ({ setLoggedIn }) => {
  const { setUserDetails } = useContext(UserContext);
  const [freshToken, setFreshToken] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [showMessage, setShowMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const apiUrl = process.env.REACT_APP_BACKEND_API;

  useEffect(() => {
    if (!freshToken) {
      localStorage.removeItem('token');
      localStorage.removeItem('regular');
      localStorage.removeItem('user');
    }
  }, [freshToken]);

  const { mutate: loginUserMutate } = useMutation({
    mutationFn: (login) =>
      fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        body: JSON.stringify(login),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        localStorage.setItem('token', response.token);
        localStorage.setItem('regular', JSON.stringify(true));
        if (localStorage.getItem('user')) localStorage.removeItem('user') 
        setUserDetails(response);
        setFreshToken(true);
        setLoggedIn(true);
        return;
      }
      setShowMessage(true);
      if (response.statusCode === 401 || response.statusCode === 400)
        setErrorMessage('Podaci nisu ispravni!');
      else if (response.statusCode === 429)
        setErrorMessage(
          'Previše neuspjelih pokušaja prijave. Probajte kasnije.'
        );
      else setErrorMessage('Trenutno nije moguće izvršiti prijavu.');
    },
    onError: () => {
      setShowMessage(true);
    },
  });

  const { mutate: loginGuestMutate } = useMutation({
    mutationFn: (login) =>
      fetch(`${apiUrl}/auth/guest`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        localStorage.setItem('token', response.token);
        localStorage.setItem('user', "guest");
        setUserDetails({ ...response, username: 'guest' });
        setFreshToken(true);
        setLoggedIn(true);
        return;
      }
      setShowMessage(true);
      if (response.statusCode === 429)
        setErrorMessage(
          'Iskoristili se limit pristupa bez prijave. Probajte kasnije.'
        );
      else setErrorMessage('Trenutno nije moguće izvršiti prijavu.');
    },
    onError: () => {
      setShowMessage(true);
    },
  });

  useEffect(() => {
    let timeoutId;

    if (showMessage) {
      timeoutId = setTimeout(() => {
        setShowMessage(false);
      }, 3000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [showMessage]);

  return (
    <div className="login-container">
      <div className="form-side">
        <img
          src={logoWaterSystem}
          alt="water system logo"
          className="ws-logo"
        />

        <form>
          <div className="login-form">
            <h3 className="login-form-title">Korisničko ime</h3>
            <div className="login-form-input">
              <input
                type="text"
                className="login-input"
                placeholder="ime.prezime"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />

              <div className="login-input-icon">
                <UserIcon className="login-icon" />
              </div>
            </div>

            <h3 className="login-form-title">Šifra</h3>
            <div className="login-form-input">
              <input
                type="password"
                className="login-input"
                placeholder="*********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <div className="login-input-icon">
                <PasswordIcon className="login-icon" />
              </div>
            </div>
          </div>

          <button
            className="login-button"
            disabled={showMessage}
            onClick={(e) => {
              e.preventDefault();
              loginUserMutate({ username, password });
            }}
          >
            Prijava
          </button>

          <h5 className="without-login" onClick={() => loginGuestMutate()}>
            nastavi bez prijave
          </h5>
        </form>
      </div>

      <div className="illustration-side">
        <img
          src={loginIllustration}
          alt="login illustration"
          className="login-illustration"
        />
      </div>

      {showMessage && <div className="wrong-password">{errorMessage}</div>}
    </div>
  );
};

export default LoginScreen;
